(function () {
  'use strict';
  var pending;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  window.dwValidateGiftCheckout = function () {
    if (pending) return pending;
    pending = (async function () {
      var response = await fetch(root + '?section_id=side-cart', { cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to check your gift. Please try again.');
      var documentBody = new DOMParser().parseFromString(await response.text(), 'text/html');
      var metadata = documentBody.querySelector('[data-dw-gift-validation]');
      if (!metadata) throw new Error('Unable to check your gift. Please refresh your cart.');
      var state = JSON.parse(metadata.textContent);
      if (state.removeKeys.length) {
        var updates = {};
        state.removeKeys.forEach(function (key) { updates[key] = 0; });
        var mainForm = document.querySelector('form.form-cart');
        var mainSection = mainForm && mainForm.closest('[id^="shopify-section-"]');
        var sections = ['side-cart'];
        if (mainSection) sections.push(mainSection.id.replace('shopify-section-', ''));
        response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname })
        });
        var updatedCart = await response.json();
        if (!response.ok) throw new Error(updatedCart.description || 'Unable to remove the ineligible gift.');
        window.cart = updatedCart;
        state.itemCount = updatedCart.item_count;
        if (window.ajaxCart && updatedCart.sections) {
          window.ajaxCart.load(updatedCart, false);
          if (mainSection) window.ajaxCart.refreshPage(updatedCart);
        }
      }
      if (!state.itemCount) {
        window.location.assign(root + 'cart');
        return false;
      }
      return true;
    })().finally(function () { pending = null; });
    return pending;
  };

  // Reconcile gifts as soon as AJAX quantity/removal renders a new cart.
  // A missing gift never prevents checkout or causes a gift to be added.
  var reconcileTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      var invalidGift = Array.from(document.querySelectorAll('[data-dw-gift-validation]')).some(function (node) {
        try { return JSON.parse(node.textContent).removeKeys.length > 0; }
        catch (error) { return false; }
      });
      if (!invalidGift || pending) return;
      window.dwValidateGiftCheckout().catch(function (error) { console.error('Gift cart reconciliation failed:', error); });
    }, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Native Shopify checkout, including the main cart and drawer forms.
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart"]') || !event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var button = event.submitter;
    if (button.disabled) return;
    button.disabled = true;
    try {
      if (!await window.dwValidateGiftCheckout()) return;
      var note = form.querySelector('[name="note"]');
      if (note) {
        var saved = await fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
        if (!saved.ok) throw new Error('Unable to save your order note. Please try again.');
      }
      window.location.assign(root + 'checkout');
    } catch (error) {
      window.alert(error.message);
    } finally {
      button.disabled = false;
    }
  }, true);
})();
